import { Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs';

import { Activity } from '@features/dashboard/models/activity';
import { DashboardService } from '@features/dashboard/services/dashboard.service';

@Component({
  selector: 'app-lending-activity',
  templateUrl: './lending-activity.component.html',
  styleUrls: ['./lending-activity.component.scss']
})
export class LendingActivityComponent implements OnInit {

  public activities$!: Observable<Activity[]>;

  constructor(
    private dashboardService: DashboardService) { }

  ngOnInit(): void {
    this.activities$ = this.dashboardService.getLendingActivity();
  }

}
